import mod from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./loading.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./loading.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/_base/loading/africa/loading.vue?vue&type=script&lang=js
// module id = UzaL
// module chunks = 37